import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing } from 'src/types/columnFlags';
const controlledActions = {
    create: [488],
    fetch: [489],
    update: [490],
    delete: [491],
    downloadList: [489],
    uploadList: [-1]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'id', style: 'width:80px', isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing },
        { name: 'controlled_action_id', references: 'controlled_actions.controlled_actions' },
        { name: 'controlled_action_group_id', references: 'controlled_actions.controlled_action_groups' }
    ];
};
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    remoteEntityName: 'controlled_actions.ca_cag_rel',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Controlled actions to controlled action groups rel'
});
export default localEntity;
